<div class="row nested-row align-items-center pt-2">
  <div class="col-auto">
    <span class="bold">ATTACHMENTS</span>
  </div>
  <div class="col-auto" style="max-width: 100%">
    <ul class="list-inline">
      <li *ngFor="let item of attachmentList | rmsUnique; let i = index" [title]="item.fileName">
        <i class="fa fa-{{item.fileType?.className}}" [ngStyle]="{'color': item.fileType?.color}"></i>
        {{item.fileName}}
        <span class="remove" (click)="removeItem(i)">
          <i class="fa fa-times"></i>
        </span>
      </li>
    </ul>
  </div>
</div>
